import { render, staticRenderFns } from "./addOrUpdate.vue?vue&type=template&id=bdde6d5e&scoped=true"
import script from "./addOrUpdate.vue?vue&type=script&lang=js"
export * from "./addOrUpdate.vue?vue&type=script&lang=js"
import style0 from "./addOrUpdate.vue?vue&type=style&index=0&id=bdde6d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdde6d5e",
  null
  
)

export default component.exports